<template>
  <div id="contenedor-configuracion-minutas-main">
    <v-toolbar flat>
      <v-toolbar-title> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        small
        class="text-capitalize"
        @click="mostrarAgregarTema = true"
      >
        <v-icon left small>
          mdi-plus
        </v-icon>
        Agregar Tema
      </v-btn>
    </v-toolbar>
    <Listado :idContrato="idContrato" />
    <!-- Ventana Agregar Tema -->
    <v-dialog v-if="mostrarAgregarTema" v-model="mostrarAgregarTema" width="500">
      <AgregarTema :idContrato="idContrato" v-on:cerrar="cerrarVentana" />
    </v-dialog>
  </div>
</template>

<script>
import AgregarTema from '@/components/administracion/contratos/contrato/temas/Agregar.vue';
import Listado from '@/views/contratistas/contratos/contrato/minutas/configuracion/Listado.vue';

export default {
  name: 'ConfiguracionMinutasMain',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  components: {
    AgregarTema,
    Listado,
  },
  data() {
    return {
      mostrarAgregarTema: false,
      mostrarEditarSubTema: false,
      mostrarEliminarSubTema: false,
      esteSubTema: null,
      esteTema: null,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarAgregarTema = false;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
